module.exports = {

    STATUS_START_DATE_PAST: 'startDateInPast',
    STATUS_PRE_REFERRAL: 'preReferal',
    STATUS_REFERRAL: 'referral',

    set: function(status, displayMessage, quoteId) {

        let n = {
            "status": status,
            "displayError": displayMessage,
            "quoteNumber": quoteId
        };

        window.localStorage.setItem('quote_error', JSON.stringify(n));
    },
    get: function() {
        return JSON.parse(window.localStorage.getItem('quote_error'));
    },
    clear: function() {
        window.localStorage.removeItem('quote_error');
    },
    getStatusFromString: function(errorString) {

        if (errorString == "Start date cannot be in the past") {
            return this.STATUS_START_DATE_PAST;
        } else {
            return false;
        }
    }
};



/** WEBPACK FOOTER **
 ** ./src/components/Managers/QuoteError.js
 **/